import Tdg_CompanyProfessionListPagingResultModelBase from '../_generated/modelBases/tdg-company-profession-list-paging-result-model-base';

export default class Tdg_CompanyProfessionListPagingResultModel extends Tdg_CompanyProfessionListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
